const cocoaBeans = require("./cocoa-beans.jpg").default;
const spice = require("./spice.jpg").default;
const ginger = require("./ginger.jpg").default;
const spice2 = require("./spice2.jpg").default;
const cocoa = require("./cocoa.jpg").default;
const spoons = require("./spoons.jpg").default;
const owner = require("./owner.jpeg").default;
const logo = require("./logo.jpeg").default;
const HeroImage = require("./heroImage.jpeg").default;
const coffeebeans = require("./coffeebeans.jpeg").default;
const spices = require("./spices.jpeg").default;
const mixedSpices = require("./mixedSpices.jpeg").default;
const seedJar = require("./seedjar.jpeg").default;
const sponSpices = require("./spoonSpices.jpeg").default;
const freshGinger = require("./freshGinger.jpeg").default;

export {
  sponSpices,
  freshGinger,
  HeroImage,
  cocoaBeans,
  coffeebeans,
  mixedSpices,
  seedJar,
  spice,
  spices,
  ginger,
  spice2,
  cocoa,
  spoons,
  owner,
  logo,
};
